import { render, staticRenderFns } from "./DisposalRowStatus.vue?vue&type=template&id=3845b332"
import script from "./DisposalRowStatus.vue?vue&type=script&lang=js"
export * from "./DisposalRowStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports